import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryOverview() {
  return (
    <section className="w-full py-14 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            资源分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            八大资源分类，覆盖工作、学习、娱乐全场景，快速找到您需要的软件和工具
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.count} 款资源
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部分类
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}